import moment from 'moment-timezone'
const defaultTimezone = {
	title: 'Timezone',
	type: 'string',
	enum: moment.tz.names()
}

export { defaultTimezone }
